import StatesPage from "../../pages/legacy/states/StatesPage";

const route = {
  key: "states",
  path: "/legacy/states",
  component: StatesPage,
  private: true,
  layout: "main",
  icon: "faMap",
  group: "masterdata",
  order: 40,
  permission: "legacy.states.read"
};

export default route;